import { IResult } from '../../types/api';
import { axiosInstance } from '../Api';
import { IInsituPoint } from './FileEndPoint';

export default class InsituPoint {
  endPoint = 'InSitu';

  async getInsituPoints(): Promise<IInsituPoint[]> {
    try {
      const r = await axiosInstance.get<IInsituPoint[]>(
        `/${this.endPoint}/GetPoints`
      );
      if (!r.data) {
        return [];
      }
      return r.data;
    } catch {
      return [];
    }
  }

  async getParametersInsitu() {
    try {
      const url = `/${this.endPoint}/GetParameters`;
      const r = await axiosInstance.get(url);
      if (r.data.Error) {
        return [];
      }
      return r.data;
    } catch (error) {
      return [];
    }
  }

  async deleteInsituPoint(datasetId: string) {
    const url = `/${this.endPoint}?datasetId=${datasetId}`;
    const r = await axiosInstance.delete(url);
    return r.data;
  }

  async uploadInsituPoint(file: File) {
    const formData = new FormData();
    formData.append('files', file);

    try {
      const url = `/${this.endPoint}/Upload`;
      const r = await axiosInstance.post<IResult<string>>(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return r.data;
    } catch (error) {
      return undefined;
    }
  }

  async checkUploadStatus(pointName: string) {
    try {
      const url = `${this.endPoint}/CheckUploadStatus?pointName=${pointName}`;
      const r = await axiosInstance.get<boolean>(url);
      return r.data;
    } catch (error) {
      return undefined;
    }
  }
}
